import React, { MouseEventHandler } from "react";
import { Row, Col, Modal } from "antd";
import styles from "../DashBoard/DashBoard.module.scss";
import CustomButton from "../../common/Buttons/CustomButton";

type Props = {
  isRemoveModalVisible: boolean;
  setIsRemoveModalVisible: Function;
  handleYesRemove: MouseEventHandler<HTMLElement>;
};

const RemoveFavoriteModal: React.FC<Props> = ({
  isRemoveModalVisible,
  setIsRemoveModalVisible,
  handleYesRemove,
}) => {

  const handleClose = () => setIsRemoveModalVisible(false);

  return (
    <Modal
      className={styles.removeFavModal}
      visible={isRemoveModalVisible}
      centered={true}
      width="unset"
      footer={
        <Row justify="center" gutter={[10, 10]}>
          <Col>
            <CustomButton
              text="Close"
              type="default"
              handlerFunction={handleClose}
              id="modalWhiteBtn"
            />
          </Col>
          <Col>
            <CustomButton
              text="Yes, Remove"
              type="default"
              handlerFunction={handleYesRemove}
              id="modalBlueBtn"
            />
          </Col>
        </Row>
      }
    >
      <Row className={styles.removeFavModalContent}>
        <Col span={24}>Remove Favorite</Col>
        <Col span={24}>Are you sure you want to remove this favorite?</Col>
        <Col span={24}>This cannot be undone.</Col>
      </Row>
    </Modal>
  );
};

export default RemoveFavoriteModal;
